import { config } from "./config";

// Setup
function getConfig() {
    return { data: config };
}

export { getConfig };
